import React, {Component} from 'react';
import {Editor} from '@tinymce/tinymce-react';
import './MultiLanguageField.css';

const $ = window.$;

const LANGUAGE_LABEL_MAP = {
  zht: '繁',
  en: 'Eng',
  zhs: '简',
  th: 'ไทย'
};

const LANGUAGE_ENABLE_TEXT_MAP = {
  zht: '提供{language}翻譯內容',
  en: 'Enable {language} version content'
};

class _InputField extends Component {
  render() {
    const {fieldName, fieldType, language, isDefaultLanguage, oldValue, fieldLabel, fieldRequired, otherFieldProps} = this.props;
    const id = (isDefaultLanguage) ? `${fieldName}-input` : `${fieldName}${language}-input`;
    const name = (isDefaultLanguage) ? fieldName : `${fieldName}${language}`;

    switch (fieldType) {
      case 'text':
        return (
          <div className="input-field">
            <input
              type="text"
              name={name}
              defaultValue={oldValue}
              id={id}
              className="validate"
              required={fieldRequired}
              {...otherFieldProps} />
            <label htmlFor={id}>{fieldLabel}</label>
          </div>
        );
      case 'textarea':
        return (
          <div className="input-field">
            <textarea
              name={name}
              defaultValue={oldValue}
              id={id}
              className="materialize-textarea"
              required={fieldRequired}
              {...otherFieldProps} />
            <label htmlFor={id}>{fieldLabel}</label>
          </div>
        );
      case 'htmlEditor':
        return (
          <Editor
            apiKey="y9sinz2mm4fwg20ig8wnu6bid5dtnllg44p9ccs3z14gb1cw"
            textareaName={name}
            initialValue={oldValue}
            init={{
              plugins: 'table image autolink link',
              toolbar: 'undo redo | bold italic underline | fontselect fontsizeselect | forecolor backcolor | table image link',
              content_css: '/public/css/tinymce.css'
            }} />
        );
      default:
        return null;
    }
  }
}

export default class MultiLanguageField extends Component {
  constructor(props) {
    super(props);

    const {defaultLanguage, supportLanguages, oldValues} = this.props;

    const supportLanguagesFiltered = supportLanguages.filter(language => language !== defaultLanguage);

    let enabledLanguages = {};
    for (let i = 0; i < supportLanguagesFiltered.length; i++) {
      enabledLanguages[supportLanguagesFiltered[i]] = oldValues !== null && oldValues[supportLanguagesFiltered[i]] !== null;
    }

    this.supportLanguages = supportLanguagesFiltered;

    this.state = {
      enabledLanguages: enabledLanguages
    };
  }

  componentDidMount() {
    $('ul.tabs').tabs();
  }

  onEnableLanguageChange = (event, language) => {
    const enabled = event.target.checked;
    this.setState((oldState) => ({
      enabledLanguages: {
        ...oldState.enabledLanguages,
        [language]: enabled
      }
    }));
  }

  render() {
    const {fieldName, fieldType, defaultLanguage, oldValues, fieldLabel, fieldRequired, otherFieldProps, browserLang} = this.props;
    const {supportLanguages} = this;
    const {enabledLanguages} = this.state;

    return (
      <div>
        <ul className="tabs">
          <li className="multi-language-tab tab">
            <a href={`#${fieldName}-${defaultLanguage}-input-tab`} className="multi-language-tab-label">{LANGUAGE_LABEL_MAP[defaultLanguage]}</a>
          </li>
          {supportLanguages.map(language => (
            <li key={language} className="multi-language-tab tab">
              <a href={`#${fieldName}-${language}-input-tab`} className="multi-language-tab-label">{LANGUAGE_LABEL_MAP[language]}</a>
            </li>
          ))}
        </ul>

        <div id={`${fieldName}-${defaultLanguage}-input-tab`}>
          <_InputField
            fieldName={fieldName}
            fieldType={fieldType}
            language={defaultLanguage}
            isDefaultLanguage={true}
            oldValue={(oldValues) ? oldValues[defaultLanguage] : ''}
            fieldLabel={fieldLabel}
            fieldRequired={fieldRequired}
            otherFieldProps={otherFieldProps} />
        </div>

        {supportLanguages.map(language => {
          let inputFieldContainerClassName = '';
          if (!enabledLanguages[language]) {
            inputFieldContainerClassName += ' input-field-hide';
          }

          return (
            <div key={language} id={`${fieldName}-${language}-input-tab`}>
              <p>
                <input
                  type="checkbox"
                  name={`chk${fieldName}${language}`}
                  id={`enable-${fieldName}-${language}`}
                  checked={enabledLanguages[language]}
                  onChange={event => this.onEnableLanguageChange(event, language)} />
                <label htmlFor={`enable-${fieldName}-${language}`}>
                  {LANGUAGE_ENABLE_TEXT_MAP[browserLang].replace('{language}', LANGUAGE_LABEL_MAP[language])}
                </label>
              </p>

              <div className={inputFieldContainerClassName}>
                <_InputField
                  fieldName={fieldName}
                  fieldType={fieldType}
                  language={language}
                  isDefaultLanguage={false}
                  oldValue={(oldValues) ? oldValues[language] : ''}
                  fieldLabel={fieldLabel}
                  fieldRequired={false}
                  otherFieldProps={otherFieldProps} />
              </div>
            </div>
          );
        })}
      </div>
    );
  }
};
